import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { useCallback, useMemo, useState } from 'react';
import { MenuButton } from '../../Finance2/common-grid-defs/MenuButton';
import { deleteFundReservesViewPrefs } from './fundReservesViewPrefs';

export function useFundReservesViewPrefs() {
  const [renderKey, setRenderKey] = useState(0);

  const onReset = useCallback(() => {
    deleteFundReservesViewPrefs();
    setRenderKey((prev) => prev + 1);
  }, []);

  return { renderKey: String(renderKey), onReset };
}

interface IReservesGridMenuProps {
  onReset: () => void;
}
export function ReservesGridMenu({ onReset }: IReservesGridMenuProps) {
  const menuItems = useMemo(
    () => [
      {
        name: 'Reset view to default',
        icon: <RestartAltOutlinedIcon />,
        onClick: onReset,
      },
    ],
    [onReset]
  );
  return <MenuButton menuItems={menuItems} label='view options' />;
}
